import { ControlUser } from './controlUser';
import { Deserializable } from './deserializable';


export class UserOwnerRel implements Deserializable {

  userUid: string;
  ownerUid: string;
  user: ControlUser;
  activationCode: string;
  name: string;
  id: number;
  groupName: string;
  groupId: number;
  description : string ;

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
